(function(angular) {
  'use strict';
  angular
  .module('opinator', [])
  .run(runOpinator)
// http://localhost:3000/local_kyop/bbvaoneview_login.html#!/?opinator=boss_web_1Q2018_logout
  runOpinator.$inject = ['$log','$location', '$rootScope'];
  function runOpinator($log, $location, $rootScope) {
    var destroy = $rootScope.$on('$locationChangeSuccess', function (e) {
      var queryParams = $location.search();
      $log.log('$location', $location)
      if (angular.isDefined(queryParams.opinator)) {
        var criptedRef = sessionStorage.getItem('criptedRef');
        criptedRef = criptedRef !== null ? criptedRef : undefined;
        OPINATOR.showOpi(queryParams.opinator, criptedRef)
        $location.path(opinator, null); // borra de la url
        // OPINATOR.showOpi("boss_web_1Q2018_logout");
      }
   });
  }
}(angular));
